export const INCREASE_STEP = "INCREASE_STEP";
export const DECREASE_STEP = "DECREASE_STEP";

export const OPEN_UPLOAD_ART_MODAL = "OPEN_UPLOAD_ART_MODAL";
export const CLOSE_UPLOAD_ART_MODAL = "CLOSE_UPLOAD_ART_MODAL";
